export default customElements.define('w-avatar', class Avatar extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-avatar';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
            <div data-root>
                <button class="${styleSelector}__button" type="button" data-button>
                    <img class="${styleSelector}__image u-margin__bottom-mobile--spacing-m" data-image />
                    <p class="u-text__weight--bold u-margin__bottom-mobile--0" data-label></p>
                    <p data-sublabel></p>
                </button>
                <span data-slot="modal" data-modal></span>
            </div>`,
            hasChildren: true,
            cacheDom: [ 'data-label', 'data-sublabel', 'data-modal', 'data-image', 'data-button' ]
        };

        super(config);
        
        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            this.#setupModal();
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('image-src', {required: true}),
            new wealthify.Prop('hover-image-src'),
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('sub-label'),
        ];
    }

    focusOrMouseEnterHandlerReference = (() => {
        this.dom.image.src = this.hoverImageSrc;
        this.dom.label.textContent = `Click to find out more about ${this.label.split(' ')[0]}`;
        this.dom.sublabel.textContent = '';
    }).bind(this);

    blurOrMouseLeaveHandlerReference = (() => {
        this.dom.image.src = this.imageSrc;
        this.dom.label.textContent = `${this.label}`;
        this.dom.sublabel.textContent = this.subLabel;
    }).bind(this);

    get propCallbacks () {
        return {
            imageSrc: () => this.dom.image.src = this.imageSrc,
            hoverImageSrc: () => {
                const eventListenerAction = this.hoverImageSrc ? 'addEventListener' : 'removeEventListener';

                this.dom.button[eventListenerAction]('mouseenter', this.focusOrMouseEnterHandlerReference);
                this.dom.button[eventListenerAction]('focus', this.focusOrMouseEnterHandlerReference);
                this.dom.button[eventListenerAction]('mouseleave', this.blurOrMouseLeaveHandlerReference);
                this.dom.button[eventListenerAction]('blur', this.blurOrMouseLeaveHandlerReference);
            },
            label: (value) => {
                this.dom.label.textContent = value;
                this.#updateAriaLabel();            
            },
            subLabel: (value) => {
                this.dom.sublabel.textContent = value;
                this.#updateAriaLabel();
            },
        };
    }

    #updateAriaLabel(){
        const subLabelString = this.subLabel ? `, ${this.subLabel}` : '';

        this.dom.button.ariaLabel = `Find out more about ${this.label}${subLabelString}`;
    }

    #setupModal () {
        // TODO - Consider during slot refactor (PDB-1008)
        if(this.dom.modal){
            this.dom.modal.variant = 'takeover';
            
            this.dom.button.addEventListener('click', (e) => {
                const cancelModalRefocus = !wealthify.event.isKeyboardEvent(e);
                            
                this.dom.modal.open = true;
                this.dom.modal.cancelRefocus = cancelModalRefocus;
            });
        }else{
            this.dom.button.style.cursor = 'default';
        }
    }
});